import React from "react";
import Header from "../../Header/Header";
import topFrame from "./Frame 3.png";
import HomeInspectorConfirmation from "./../../../assets/images/HomeInspectorConfirmation.png";

import { useNavigate } from "react-router-dom";
import { FiAlertCircle } from "react-icons/fi";
const InsuranceServiceConfirmation = () => {
    const navigate = useNavigate();

    return (
        <div className="tw-min-h-screen tw-pt-[65px] tw-h-full tw-bg-background_color tw-overflow-auto">
            <span className="">
                <Header title="Insurance Services Confirmation" />
            </span>
            <div className="tw-max-w-full tw-h-full tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-between ">
                <div></div>
                <div className="tw-flex  tw-flex-col tw-max-w-[70%] max-sm:tw-max-w-full tw-bg-white max-sm:tw-bg-transparent tw-rounded-xl tw-w-full ">
                    <div className="tw-flex tw-justify-center tw-mt-3">
                        <img src={HomeInspectorConfirmation} className="tw-w-[150px]" alt="" />
                    </div>

                    <div className="tw-rounded-lg tw-py-8 tw-flex tw-flex-col tw-gap-5 max-md:tw-px-8 tw-px-16 max-sm:tw-px-5 ">
                        <div className="tw-text-center">
                            <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-2 ">Success! Your Request Has Been Submitted</h1>
                            <p className="tw-text-gray-600 tw-text-[16px] tw-font-bold">
                                Your journey to securing the perfect insurance coverage has begun!{" "}
                            </p>
                        </div>

                        <div className="tw-space-y-6 tw-flex tw-justify-center">
                            <p className="tw-text-gray-700  tw-max-w-[920px] tw-font-medium tw-leading-tight">
                                Thank you for providing your details. Our network of top-rated insurance providers is now reviewing your request to
                                generate personalized quotes tailored to your property.
                            </p>
                        </div>

                        <div>
                            <h2 className="tw-font-semibold tw-text-[18px] tw-pb-3">What Happens Next?</h2>
                            <ul className="tw-list-disc tw-ml-5">
                                <li>
                                    {" "}
                                    <span className="tw-font-medium">Receive Quotes:</span> Expect multiple competitive insurance quotes within 24-48
                                    hours.
                                </li>
                                <li>
                                    {" "}
                                    <span className="tw-font-medium">Detailed Breakdown:</span> Each quote will include a comprehensive breakdown of
                                    coverage and costs.
                                </li>
                                <li>
                                    {" "}
                                    <span className="tw-font-medium">Receive Quotes:</span> Expert Support: Our insurance specialists are available to
                                    answer any questions and guide you through your options.
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="tw-font-semibold tw-text-[18px] tw-pb-3">Next Steps</h2>
                            <ul className="tw-list-disc tw-ml-5">
                                <li>
                                    <span className="tw-font-medium">Check Your Email:</span> Look for your quotes in your inbox (and spam folder,
                                    just in case).
                                </li>
                                <li>
                                    <span className="tw-font-medium">Compare Your Options:</span>Review the coverage details and pricing to find the
                                    best fit.
                                </li>
                                <li>
                                    <span className="tw-font-medium">Get Assistance:</span> Contact our support team for any questions or guidance.
                                </li>
                            </ul>
                        </div>

                        <div className="tw-flex tw-flex-col tw-items-center lg:tw-flex-nowrap tw-gap-4">
                            <button
                                onClick={() => {
                                    sessionStorage.removeItem("insuranceInfo");
                                    navigate("/properties");
                                }}
                                className="tw-bg-primary hover:tw-bg-primary_hover tw-w-fit tw-px-[100px] tw-text-white tw-h-[52px] tw-rounded-lg tw-transition-colors tw-text-sm"
                            >
                                Return To Home Screen
                            </button>
                            <div className="tw-flex tw-items-center tw-justify-center tw-gap-1 max-sm:tw-items-start    ">
                                <FiAlertCircle className="tw-text-[20px]" />
                                <p className="tw-text-gray-700 tw-text-center">
                                    Your home deserves the right protection—let’s find the best policy for you! 🚀{" "}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
    );
};

export default InsuranceServiceConfirmation;
